import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ColumviLogo } from './ColumviLogo';
import { ColumviBackground } from './ColumviBackground';
interface QuizSlideProps {
  onAnswerSelect: (answerId: string) => void;
}
export function QuizSlide({
  onAnswerSelect
}: QuizSlideProps) {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const handleSelect = (id: string) => {
    if (selectedId) return;
    setSelectedId(id);
    setTimeout(() => {
      onAnswerSelect(id);
    }, 500);
  };
  const options = [{
    id: 'a',
    text: 'Early response that declines over time'
  }, {
    id: 'b',
    text: 'Separation in survival curves that is maintained'
  }, {
    id: 'c',
    text: 'Similar long-term outcomes regardless of treatment'
  }];
  return <ColumviBackground showWave={false} data-id="element-163">
      <div className="flex flex-col h-full w-full p-6 relative" data-id="element-164">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6
      }} className="absolute top-6 left-6 z-20" data-id="element-165">
          <ColumviLogo size="sm" variant="light" data-id="element-166" />
        </motion.div>

        {/* Progress Indicator */}
        <div className="absolute top-8 right-6 text-white/40 text-xs font-medium tracking-wider uppercase z-20" style={{
        fontFamily: 'var(--font-gotham)'
      }} data-id="element-167">
          Q1 of 1
        </div>

        {/* Subtle KM Background Lines */}
        <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none flex items-center justify-center opacity-10" data-id="element-168">
          <svg width="100%" height="100%" viewBox="0 0 400 800" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-169">
            <path d="M50,100 L150,100 L150,200 L250,200 L250,300 L350,300 L350,400 L400,400" stroke="white" strokeWidth="2" data-id="element-170" />
            <path d="M50,100 L100,100 L100,250 L200,250 L200,450 L300,450 L300,550 L400,550" stroke="white" strokeWidth="2" strokeDasharray="10 10" data-id="element-171" />
          </svg>
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col justify-center z-10 w-full mt-12" data-id="element-172">
          <motion.h2 className="text-white text-xl leading-snug mb-8" style={{
          fontFamily: 'var(--font-gotham)',
          fontWeight: 600
        }} initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-173">
            At 3 years in 2L DLBCL, what would you expect to see if a treatment
            truly has curative potential?
          </motion.h2>

          <div className="space-y-3" data-id="element-174">
            {options.map((option, index) => {
            const isSelected = selectedId === option.id;
            return <motion.div key={option.id} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3 + index * 0.1
            }} data-id="element-175">
                  <button onClick={() => handleSelect(option.id)} disabled={selectedId !== null} className={`w-full text-left p-4 rounded-xl border transition-all duration-300 flex items-center group
                      ${isSelected ? 'bg-white/20 border-white/50 shadow-[0_0_20px_rgba(255,255,255,0.1)]' : 'bg-white/5 border-white/10 hover:bg-white/10 hover:border-white/30'}
                    `} data-id="element-176">
                    <div className={`w-7 h-7 rounded-full flex items-center justify-center mr-4 border transition-colors flex-shrink-0
                      ${isSelected ? 'bg-white text-[#163D22] border-white' : 'border-white/30 text-white/70 group-hover:border-white/60 group-hover:text-white'}
                    `} style={{
                  fontFamily: 'var(--font-gotham)',
                  fontWeight: 600,
                  fontSize: '0.875rem'
                }} data-id="element-177">
                      {option.id.toUpperCase()}
                    </div>
                    <span className={`text-base transition-colors ${isSelected ? 'text-white font-medium' : 'text-white/80 group-hover:text-white'}`} style={{
                  fontFamily: 'var(--font-gotham)'
                }} data-id="element-178">
                      {option.text}
                    </span>
                  </button>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </ColumviBackground>;
}